import React from 'react';
import TenantModuleGate from './TenantModuleGate';

interface CrmModuleGateProps {
  children: React.ReactNode;
}

const CrmModuleGate: React.FC<CrmModuleGateProps> = ({ children }) => (
  <TenantModuleGate moduleKey="crm">{children}</TenantModuleGate>
);

export default CrmModuleGate;
